"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Select = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _fieldsize = require("../form/fieldsize");

var _icon = _interopRequireDefault(require("../icon"));

var _index = _interopRequireDefault(require("./index.scss"));

var _field = require("../form/field");

var SelectOptions = function SelectOptions(_ref) {
  var role = _ref.role,
      open = _ref.open,
      options = _ref.options,
      cssClassNames = _ref.cssClassNames,
      active = _ref.active,
      dataTestId = _ref.dataTestId,
      children = _ref.children,
      onClicks = _ref.onClicks;
  var refToFocus = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    if (open && (refToFocus === null || refToFocus === void 0 ? void 0 : refToFocus.current)) {
      refToFocus.current.focus();
    }
  }, [open]);
  return _react["default"].createElement("ul", {
    className: (0, _classnames["default"])(cssClassNames === null || cssClassNames === void 0 ? void 0 : cssClassNames.options, _index["default"].options, (0, _defineProperty2["default"])({}, _index["default"].showing, open)),
    role: role
  }, options.map(function (option, index) {
    var _classNames2;

    return _react["default"].createElement("li", {
      className: (0, _classnames["default"])(cssClassNames === null || cssClassNames === void 0 ? void 0 : cssClassNames.option, _index["default"].option, (_classNames2 = {}, (0, _defineProperty2["default"])(_classNames2, _index["default"].active, active(option)), (0, _defineProperty2["default"])(_classNames2, _index["default"].disabled, option.disabled), _classNames2)),
      "data-test-id": dataTestId,
      key: "option-".concat((0, _field.makeIdFromName)(option.label))
    }, children({
      option: option,
      index: index,
      onClick: onClicks.option,
      refToFocus: refToFocus
    }));
  }));
};

var Select = function Select(_ref2) {
  var _classNames4;

  var _ref2$open = _ref2.open,
      open = _ref2$open === void 0 ? false : _ref2$open,
      _ref2$placeholder = _ref2.placeholder,
      placeholder = _ref2$placeholder === void 0 ? 'Choose an option' : _ref2$placeholder,
      disabled = _ref2.disabled,
      options = _ref2.options,
      label = _ref2.label,
      active = _ref2.active,
      _ref2$size = _ref2.size,
      size = _ref2$size === void 0 ? _fieldsize.FieldSize.DEFAULT : _ref2$size,
      innerRef = _ref2.innerRef,
      onClicks = _ref2.onClicks,
      cssClassNames = _ref2.cssClassNames,
      children = _ref2.children,
      dataTestId = _ref2.dataTestId,
      buttonDataTestId = _ref2.buttonDataTestId,
      _ref2$role = _ref2.role,
      role = _ref2$role === void 0 ? 'menu' : _ref2$role;
  var activeOption = options.find(active);
  var activeLabel = activeOption && label(activeOption) || placeholder;
  return _react["default"].createElement("div", {
    className: (0, _classnames["default"])(cssClassNames === null || cssClassNames === void 0 ? void 0 : cssClassNames.wrapper, _index["default"].group, (0, _defineProperty2["default"])({}, _index["default"].disabled, disabled))
  }, _react["default"].createElement("button", {
    ref: innerRef,
    className: (0, _classnames["default"])(cssClassNames === null || cssClassNames === void 0 ? void 0 : cssClassNames.trigger, _index["default"].trigger, (_classNames4 = {}, (0, _defineProperty2["default"])(_classNames4, _index["default"].triggerSmall, size === _fieldsize.FieldSize.SMALL), (0, _defineProperty2["default"])(_classNames4, _index["default"].triggerDefault, size === _fieldsize.FieldSize.DEFAULT), _classNames4)),
    "data-test-id": buttonDataTestId,
    onClick: onClicks.trigger,
    onTouchEnd: onClicks.trigger // so we don't try to submit a form
    ,
    type: "button"
  }, activeLabel, _react["default"].createElement(_icon["default"], {
    type: "chevron-".concat(open ? 'up' : 'down'),
    size: "small",
    className: _index["default"].icon
  })), _react["default"].createElement(SelectOptions, {
    role: role,
    open: open,
    options: options,
    cssClassNames: cssClassNames,
    active: active,
    dataTestId: dataTestId,
    children: children,
    onClicks: onClicks
  }));
};

exports.Select = Select;
var _default = Select;
exports["default"] = _default;